import Alpine from 'alpinejs';
import { register } from 'swiper/element/bundle';
import Swiper from 'swiper';
import 'swiper/css';
import Userback from '@userback/widget';
import ScrollMagic from 'scrollmagic';
import dayjs from 'dayjs';
import { load } from 'recaptcha-v3'

// import AOS
import AOS from 'aos';

window.dayjs = dayjs;


register();

window.Alpine = Alpine;

Alpine.start();

window.Swiper = Swiper;

window.ScrollMagic = ScrollMagic;

AOS.init();

// Search
document.getElementById('search-icon').addEventListener('click', function () {
  document.getElementById('search-modal').classList.toggle('hidden');
});

document.getElementById('close-icon').addEventListener('click', function () {
  document.getElementById('search-modal').classList.add('hidden');
});

(function () {
  function onReady() {
    document.querySelector('html').classList.remove('overflow-y-hidden');

    window.addEventListener("message", function (event) {
      if (event.data === "bookingConfirmation") {
        window.location.href = "/buchungsbestaetigung";
      }
    }, false);
  }

  if (document.readyState === 'complete') {
    onReady();
  } else {
    document.addEventListener('DOMContentLoaded', onReady);
  }
})();

if (process.env.MIX_USERBACK_TOKEN) {
  Userback(process.env.MIX_USERBACK_TOKEN);
}

if (process.env.MIX_RECAPTCHA_V3_SITE_KEY) {
  load(process.env.MIX_RECAPTCHA_V3_SITE_KEY, {
    explicitRenderParameters: {
      badge: 'bottomright',
      size: 'invisible',
    }
  })
    .then((recaptcha) => {
      if (document.querySelectorAll('form').length) {
        const excludedFormActions =[
          'suche', 'kontakt'
        ];
        document.querySelectorAll('form').forEach((form) => {
         
          if(form.action && excludedFormActions.some((action) => form.action.includes(action))) {
            return;
          }
          console.log('form action', form.action, form);
          form.addEventListener('submit', function (event) {
            event.target.querySelector('button[type="submit"]').disabled = true;

            event.preventDefault();

            recaptcha.execute('submit')
              .then((token) => {
                event.target.querySelector('input[name="recaptcha_token"]').value = token;
                console.log('recaptcha token', token);
                setTimeout(() => {
                  event.target.submit();
                }, 50);
              });

            setTimeout(() => {
              event.target.querySelector('button[type="submit"]').disabled = false;
            }, 500);
          });
        })
      }
    });
}

function getRecaptchaToken() {
  if (process.env.MIX_RECAPTCHA_V3_SITE_KEY) {
    return load(process.env.MIX_RECAPTCHA_V3_SITE_KEY, {
      explicitRenderParameters: {
        badge: 'bottomright',
        size: 'invisible',
      }
    })
      .then((recaptcha) => {
        return recaptcha
          .execute('submit')
          .then((token) => {
            return token;
          });
      });
  }
}

window.getRecaptchaToken = getRecaptchaToken;

